import { motion } from 'framer-motion';

export const ProductCard = ({ name, price, image, paymentLink, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-white border border-[#EADCCC] rounded-md overflow-hidden group"
      data-testid={`product-card-${name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
    >
      {/* Image */}
      <div className="product-image-wrapper aspect-[4/5] overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      
      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-[Playfair_Display] text-[#2A2626] mb-2 tracking-tight" data-testid={`product-name-${name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>
          {name}
        </h3>
        <p className="text-2xl font-[Manrope] font-semibold text-[#A85A43] mb-4" data-testid={`product-price-${name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>
          ${price}
        </p>
        <a
          href={paymentLink}
          className="block w-full text-center bg-[#A85A43] hover:bg-[#8C4935] text-white font-[Manrope] py-3 px-6 rounded-full transition-colors"
          data-testid={`buy-button-${name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
        >
          Buy Now
        </a>
      </div>
    </motion.div>
  );
};
